import React from 'react';
import { getFormData } from '../../common';
import { EverestRepository } from '../../repository';
import { NavigationBar } from './NavigationBar';

const repository = new EverestRepository();

class EverestJoinPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  componentDidMount() {
    console.log(repository);
  }

  render() {
    return (
      <>
        <NavigationBar user={{}} location={this.props.location} />
        <EverestJoinTemplate />
      </>
    );
  }
}

const EverestJoinTemplate = () => {
  return (
    <div className={"container"}>
      <div style={{ paddingTop: 30, paddingBottom: 30 }}>회원 서비스를 이용할 수 있습니다.</div>

      <div className={"row"}>
        <div className={"col-4"}></div>
        <div className={"col-4"} style={{ border: "1px solid #dedede" }}>
          <EverestJoinForm />
        </div>
        <div className={"col-4"}></div>
      </div>
    </div>
  );
};

const EverestJoinForm = () => {

  const onSubmitJoin = (e) => {
    const formData = getFormData(e.target);
    console.log(formData);
  };

  return (
    <form onSubmit={onSubmitJoin}>
      <div style={{ paddingTop: 30 }} />
      <div className={"form-group"} style={{ textAlign: "left" }}>
        <label>이메일</label>
        <input className={"form-control"} placeholder={"Email"} autoComplete={"off"} />
      </div>

      <div className={"form-group"} style={{ textAlign: "left" }}>
        <label>비밀번호</label>
        <input className={"form-control"} placeholder={"Password"} autoComplete={"off"} />
      </div>

      <div className={"form-group"} style={{ textAlign: "left" }}>
        <label>닉네임</label>
        <input className={"form-control"} placeholder={"Nickname"} autoComplete={"off"} />
      </div>

      <div className={"form-group"}>
        <button style={{ minWidth: 100 }} className={"btn btn-info"} type={"submit"}>회원가입</button>
      </div>

      <div style={{ paddingTop: 10 }} />
      <hr />

      <div className={"form-group"}>
        <a href={"/oauth2/everest/google/login"}>
          <button style={{ minWidth: 200 }} className={"btn btn-danger"}>Google 계정으로 시작하기</button>
        </a>
      </div>
    </form>
  );
};

export { EverestJoinPage };
